// extracted by mini-css-extract-plugin
export default {"posting-job-as-badge":"style_posting-job-as-badge__7jdhx","postingJobAsBadge":"style_posting-job-as-badge__7jdhx"};